import React, { AnchorHTMLAttributes, createContext } from 'react';
import { isActive } from '../components/Link/isActive';
import { isServer } from '../utils/isServer';

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  ref?: React.Ref<HTMLAnchorElement>;
  state?: object | null | undefined;
};

interface ThemeContextType {
  LinkComponent?: React.ComponentType<LinkProps>;
  isLinkActive: (path: string) => boolean;
  /** Origin of the site (e.g. https://example.com). Used by Link for external-link detection on the server when window.location is unavailable. */
  siteOrigin?: string;
}

export const ThemeContext = createContext<ThemeContextType>({
  isLinkActive: isActive(isServer() ? '' : window.location.pathname),
});
